export default {
  title: 'Punkty i zniżki',
  store_credit: 'Kredyt sklepu',
  points_balance: 'Saldo punktów',
};
